import {
  booleanValidator,
} from '../../../../../OUI/Inputs';

export const rememberDeviceValidator = booleanValidator;
